// import type { AuctionDetail, Order, SubmitOfferPayload, ProvisioningAPIRecord } from '../types'
import type { RfqBuyerView, RfqSellerView, Buyer, ProvisioningView} from './schema'
import { ProvisioningDetails } from '../components/ProvisioningTimeline'

//////////////////////////////////////////////////////////////////////////////     _                               _           _ 
//   __| | ___ _ __  _ __ ___  ___ __ _| |_ ___  __| |
//  / _` |/ _ \ '_ \| '__/ _ \/ __/ _` | __/ _ \/ _` |
// | (_| |  __/ |_) | | |  __/ (_| (_| | ||  __/ (_| |
//  \__,_|\___| .__/|_|  \___|\___\__,_|\__\___|\__,_|
//            |_|
// do NOT use this anymore unless you can't help it :)
////////////////////////////////////////////////////////////////////////


// Use a relative base so requests go to the same origin that served the page.
// - Static build served by Flask on :4000/:5001 → calls go directly to Flask.
// - Vite dev server on :3000/:3001 → Vite proxy forwards /client and /host to Flask.
// Never hardcode http://localhost:PORT here — that breaks the static build when
// the browser cannot reach Flask directly (CORS + network boundary issues).
const BASE = 'http://localhost:8000'

// Flask port for this mode — injected at build time by vite.config.ts
// Used to give actionable error messages when the backend is unreachable.
declare const __VITE_HOST_PORT__: string
/*export const FLASK_PORT: string =
  typeof __VITE_HOST_PORT__ !== 'undefined' ? __VITE_HOST_PORT__ : '5001'*/
export const FLASK_PORT: string = '4000'

export async function getBuyerRFQs(): Promise<RfqBuyerView[]> {
  return [
    {
      id: 'rfq-001',
      buyer_id: 'buyer-uuid-001',
      status: 'open',
      opened_at: '2026-06-20T08:00:00Z',
      quote_validity_s: 86400,
      rfq_validity_s: 86400,
      protection_period_from: '2026-06-27',
      protection_period_until: '2026-06-29',
      total_dirty_bandwidth_gbps: 500,
      total_clean_bandwidth_gbps: 160,
      quote_range_low: null,
      quote_range_high: null,
      total_net_price: "123.00",
      total_transaction_fees: "4.00",
      total_gross_price: "127.00",
      request_legs: [
        { id: 'leg-001', timeslot: '2026-06-27T00:00:00Z', location_id: 1, dirty_bandwidth_gbps: 300, clean_bandwidth_gbps: 100 },
        { id: 'leg-002', timeslot: '2026-06-28T00:00:00Z', location_id: 2, dirty_bandwidth_gbps: 200, clean_bandwidth_gbps: 60 },
      ],
      request_locations: [
        { location_id: 1, dirty_bandwidth_gbps: 300, clean_bandwidth_gbps: 100 },
        { location_id: 2, dirty_bandwidth_gbps: 200, clean_bandwidth_gbps: 60 },
      ],
      quotes: [],
    },
    {
      id: 'rfq-002',
      buyer_id: 'buyer-uuid-001',
      status: 'closed',
      opened_at: '2026-06-18T10:00:00Z',
      quote_validity_s: 86400,
      rfq_validity_s: 86400,
      protection_period_from: '2026-06-25',
      protection_period_until: '2026-06-26',
      total_dirty_bandwidth_gbps: 500,
      total_clean_bandwidth_gbps: 160,
      quote_range_low: null,
      quote_range_high: null,
      total_net_price: "123.00",
      total_transaction_fees: "4.00",
      total_gross_price: "127.00",
      request_legs: [
        { id: 'leg-003', timeslot: '2026-06-25T00:00:00Z', location_id: 1, dirty_bandwidth_gbps: 250, clean_bandwidth_gbps: 80 },
        { id: 'leg-004', timeslot: '2026-06-26T00:00:00Z', location_id: 2, dirty_bandwidth_gbps: 250, clean_bandwidth_gbps: 80 },
      ],
      request_locations: [
        { location_id: 1, dirty_bandwidth_gbps: 250, clean_bandwidth_gbps: 80 },
        { location_id: 2, dirty_bandwidth_gbps: 250, clean_bandwidth_gbps: 80 },
      ],
      quotes: [
        {
          vendor_id: 1, seller_id: 'seller-uuid-001', seller_name: 'Nexusguard',
          is_awarded: false,
          locations: [
            {
              location_id: 1, dirty_bandwidth_gbps: 250,
              dirty_bandwidth_total_price: '200', clean_bandwidth_gbps: 80,
              clean_bandwidth_total_price: '150',
            },
            {
              location_id: 2, dirty_bandwidth_gbps: 250,
              dirty_bandwidth_total_price: '150', clean_bandwidth_gbps: 80,
              clean_bandwidth_total_price: '100',
            }
          ],
          total_net_price: '350', transaction_fees: '15', total_gross_price: '365',
        },
      ],
    },
    {
      id: 'rfq-003',
      buyer_id: 'deadbeef-0000-0000-0000-0000000000b1',
      status: 'settled',
      opened_at: '2026-06-15T09:00:00Z',
      quote_validity_s: 86400,
      rfq_validity_s: 86400,
      protection_period_from: '2026-06-24',
      protection_period_until: '2026-06-25',
      total_dirty_bandwidth_gbps: 500,
      total_clean_bandwidth_gbps: 160,
      quote_range_low: null,
      quote_range_high: null,
      total_net_price: "123.00",
      total_transaction_fees: "4.00",
      total_gross_price: "127.00",
      request_legs: [
        { id: 'leg-005', timeslot: '2026-06-24T00:00:00Z', location_id: 1, dirty_bandwidth_gbps: 400, clean_bandwidth_gbps: 120 },
      ],
      request_locations: [
        { location_id: 1, dirty_bandwidth_gbps: 400, clean_bandwidth_gbps: 120 },
      ],
      quotes: [{
        vendor_id: 1, seller_id: 'seller-uuid-001', seller_name: 'Nexusguard',
        is_awarded: true,
        locations: [{
          location_id: 1, dirty_bandwidth_gbps: 400,
          dirty_bandwidth_total_price: '320', clean_bandwidth_gbps: 120,
          clean_bandwidth_total_price: '240',
        }],
        total_net_price: '560', transaction_fees: '22', total_gross_price: '582',
      }],
    },
    {
      id: 'rfq-004',
      buyer_id: 'deadbeef-0000-0000-0000-0000000000b1',
      status: 'failed',
      opened_at: '2026-06-14T09:00:00Z',
      quote_validity_s: 86400,
      rfq_validity_s: 86400,
      protection_period_from: '2026-06-26',
      protection_period_until: '2026-06-27',
      total_dirty_bandwidth_gbps: 500,
      total_clean_bandwidth_gbps: 160,
      quote_range_low: "312",
      quote_range_high: "312",
      total_net_price: "123.00",
      total_transaction_fees: "4.00",
      total_gross_price: "127.00",
      request_legs: [
        { id: 'leg-006', timeslot: '2026-06-24T00:00:00Z', location_id: 2, dirty_bandwidth_gbps: 200, clean_bandwidth_gbps: 60 },
      ],
      request_locations: [
        { location_id: 1, dirty_bandwidth_gbps: 200, clean_bandwidth_gbps: 60 },
      ],
      quotes: [{
        vendor_id: 1, seller_id: 'seller-uuid-001', seller_name: 'Blindspot',
        is_awarded: true,
        locations: [{
          location_id: 2, dirty_bandwidth_gbps: 200,
          dirty_bandwidth_total_price: '180', clean_bandwidth_gbps: 60,
          clean_bandwidth_total_price: '120',
        }],
        total_net_price: '300', transaction_fees: '12', total_gross_price: '312',
      }],
    },
  ]
}
// ── END MOCK ──
// TODO: const res = await fetch('/api/buyer/rfqs', { headers: getAuthHeader() })
// if (!res.ok) throw new Error(`getBuyerRFQs: ${res.status}`)
// return res.json()




/**
 * POST /client/submit_order/
 * Posts a reverse auction (one per 1-hour slot) on-chain.
 */
// export async function submitOrder(order: Order): Promise<void> {
//   const res = await fetch(`${BASE}/client/submit_order/`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json', ...authHeaders() },
//     body: JSON.stringify(order),
//   })
//   if (!res.ok) throw new Error(`submitOrder: ${res.status}`)
// }

export async function getSellerRFQs(): Promise<RfqSellerView[]> {
  // ── MOCK — remove when backend ready ──
  return [
    {
      id: '1',
      rfq_id: 'rfq-001',
      vendor_id: 1,
      seller_id: 'seller-uuid-001',
      status: 'closed',
      buyer_id: 'buyer-uuid-002',
      buyer_name: 'GlobalNet ISP',
      opened_at: '2026-06-20T08:00:00Z',
      quote_validity_s: 86400,
      rfq_validity_s: 86400,
      protection_period_from: '2026-06-26',
      protection_period_until: '2026-06-28',
      total_dirty_bandwidth_gbps: 500,
      total_clean_bandwidth_gbps: 160,
      total_quoted_price: null,
      request_legs: [
        { id: 'leg-001', timeslot: '2026-06-24T00:00:00Z', location_id: 1, dirty_bandwidth_gbps: 300, clean_bandwidth_gbps: 100 },
        { id: 'leg-002', timeslot: '2026-06-24T00:00:00Z', location_id: 2, dirty_bandwidth_gbps: 200, clean_bandwidth_gbps: 60 },
      ],
      request_locations: [
        { location_id: 1, dirty_bandwidth_gbps: 300, clean_bandwidth_gbps: 100 },
        { location_id: 2, dirty_bandwidth_gbps: 200, clean_bandwidth_gbps: 60 },
      ],
      has_declined_rfq: false,
      has_quoted: false,
      quote: null,
    },
    {
      id: '2',
      rfq_id: 'rfq-002',
      vendor_id: 1,
      seller_id: 'seller-uuid-001',
      status: 'open',
      buyer_id: '-',
      buyer_name: '-',
      opened_at: '2026-06-18T10:00:00Z',
      quote_validity_s: 86400,
      rfq_validity_s: 86400,
      protection_period_from: '2026-06-24',
      protection_period_until: '2026-06-25',
      total_dirty_bandwidth_gbps: 500,
      total_clean_bandwidth_gbps: 160,
      total_quoted_price: null,
      request_legs: [
        { id: 'leg-003', timeslot: '2026-06-24T00:00:00Z', location_id: 1, dirty_bandwidth_gbps: 250, clean_bandwidth_gbps: 80 },
      ],
      request_locations: [
        { location_id: 1, dirty_bandwidth_gbps: 250, clean_bandwidth_gbps: 80 }
      ],
      has_declined_rfq: false,
      has_quoted: true,
      quote: null,
    },
    {
      id: '3',
      rfq_id: 'rfq-003',
      vendor_id: 1,
      seller_id: 'seller-uuid-001',
      status: 'won',
      buyer_id: 'buyer-uuid-002',
      buyer_name: 'GlobalNet ISP',
      opened_at: '2026-06-18T10:00:00Z',
      quote_validity_s: 86400,
      rfq_validity_s: 86400,
      protection_period_from: '2026-06-24',
      protection_period_until: '2026-06-25',
      total_dirty_bandwidth_gbps: 500,
      total_clean_bandwidth_gbps: 160,
      total_quoted_price: null,
      request_legs: [
        { id: 'leg-004', timeslot: '2026-06-24T00:00:00Z', location_id: 1, dirty_bandwidth_gbps: 250, clean_bandwidth_gbps: 80 },
      ],
      request_locations: [
        { location_id: 1, dirty_bandwidth_gbps: 250, clean_bandwidth_gbps: 80 },
      ],
      has_declined_rfq: false,
      has_quoted: true,
      quote: null,
    },
  ]
  // ── END MOCK ──

  // TODO: replace with real call:
  // const res = await fetch('/api/seller/rfqs', { headers: getAuthHeader() })
  // if (!res.ok) throw new Error(`getSellerRFQs: ${res.status}`)
  // return res.json()
}


export async function getSellerProvisionings(): Promise<ProvisioningView[]> {
  // ── MOCK ──
  return [
    {
      id: 'prov-001',
      buyer_id: 'buyer-uuid-001',
      buyer_name: 'Acme Corp',
      seller_id: 'seller-uuid-001',
      seller_name: 'Nexusguard',
      location_id: 1,
      initiated_at: '2026-06-20T08:00:00Z',
      status: 'in_progress',
      period_from: '2026-06-26',
      period_until: '2026-06-28',
      dirty_bandwidth_gbps: 300,
      clean_bandwidth_gbps: 100,
      fail_cause: null,
      fail_reason: null,
      submissions: [
        {
          id: 2,
          submitted_at: '2026-06-14T10:22:00Z',
          status: 'submitted',
          decline_reason: null,
          details: {
            asn: 'ASN00009',
            ip_prefixes: ['203.0.113.0/24'],
            latency_sensitivity_ms: 10,
            model_of_routers: ['Cisco ASR 9000'],
            location_of_idc: 'Singapore DC1',
            tunnel_endpoints: [
              { router_designation: 'PE-1', tunnel_endpoint_ip: '192.0.2.1' },
            ],
            netflow_details: [
              { netflow_ip: '10.0.0.1', netflow_version: 'v9', netflow_sampling_rate: '1:1000' },
            ],
            whitelisted_ips: ['10.0.0.0/8'],
            monitoring_ips: ['10.0.0.2'],
            protocol_and_ports: ['TCP/443', 'UDP/53'],
            ids_ips_or_gslb_presence: ['Palo Alto NGFW'],
            additional_information: 'Primary link via SingTel',
          },
        },
        {
          id: 1,
          submitted_at: '2026-06-10T09:30:00Z',
          status: 'declined',
          decline_reason: 'Too broad — use /24 or smaller.',
          details: {
            asn: 'ASN00009',
            ip_prefixes: ['10.0.0.0/8'],
            latency_sensitivity_ms: 10,
            model_of_routers: ['Cisco ASR 9000'],
            location_of_idc: 'Singapore DC1',
            tunnel_endpoints: [
              { router_designation: 'PE-1', tunnel_endpoint_ip: '192.0.2.5' },
            ],
            netflow_details: [],
            whitelisted_ips: [],
            monitoring_ips: [],
            protocol_and_ports: [],
            ids_ips_or_gslb_presence: [],
            additional_information: '',
          },
        },
      ],
    },
    {
      id: 'prov-002',
      buyer_id: 'deadbeef-0000-0000-0000-0000000000b1',
      buyer_name: 'Acme Corp',
      seller_id: 'seller-uuid-001',
      seller_name: 'Nexusguard',
      location_id: 1,
      initiated_at: '2026-06-18T10:00:00Z',
      status: 'in_progress',
      period_from: '2026-06-24',
      period_until: '2026-06-25',
      dirty_bandwidth_gbps: 250,
      clean_bandwidth_gbps: 80,
      fail_cause: null,
      fail_reason: null,
      submissions: [
        {
          id: 1,
          submitted_at: '2026-06-14T10:22:00Z',
          status: 'submitted',
          decline_reason: null,
          details: {
            asn: 'ASN00009',
            ip_prefixes: ['203.0.113.0/23'],
            latency_sensitivity_ms: 10,
            model_of_routers: ['Cisco ASR 9000'],
            location_of_idc: 'Singapore DC1',
            tunnel_endpoints: [
              { router_designation: 'PE-1', tunnel_endpoint_ip: '192.0.2.1' },
            ],
            netflow_details: [                              // ← was []
              { netflow_ip: '10.0.0.1', netflow_version: 'v9', netflow_sampling_rate: '1:1000' },
            ],
            whitelisted_ips: ['10.0.0.0/8'],       // ← was []
            monitoring_ips: ['10.0.0.2'],          // ← was []
            protocol_and_ports: ['TCP/443', 'UDP/53'], // ← was []
            ids_ips_or_gslb_presence: ['Palo Alto NGFW'],    // ← was []
            additional_information: 'Primary link via SingTel',
          },
        },
      ],
    },
  ]
  // ── END MOCK ──
  // TODO: const res = await fetch('/api/seller/provisioning', { headers: getAuthHeader() })
  // if (!res.ok) throw new Error(`getSellerProvisionings: ${res.status}`)
  // return res.json()
}

export async function getBuyerProvisionings(): Promise<ProvisioningView[]> {
  // ── MOCK ──
  return [
    {
      id: 'prov-001',
      buyer_id: 'deadbeef-0000-0000-0000-0000000000b1',
      buyer_name: 'Acme Corp',
      seller_id: 'seller-uuid-001',
      seller_name: 'Nexusguard',
      location_id: 1,
      initiated_at: '2026-06-20T08:00:00Z',
      status: 'in_progress',
      period_from: '2026-06-26',
      period_until: '2026-06-28',
      dirty_bandwidth_gbps: 300,
      clean_bandwidth_gbps: 100,
      fail_cause: null,
      fail_reason: null,
      submissions: [],   // buyer hasn't submitted yet
    },
    {
      id: 'prov-002',
      buyer_id: 'deadbeef-0000-0000-0000-0000000000b1',
      buyer_name: 'Acme Corp',
      seller_id: 'seller-uuid-001',
      seller_name: 'Nexusguard',
      location_id: 1,
      initiated_at: '2026-06-18T10:00:00Z',
      status: 'in_progress',
      period_from: '2026-06-24',
      period_until: '2026-06-25',
      dirty_bandwidth_gbps: 250,
      clean_bandwidth_gbps: 80,
      fail_cause: null,
      fail_reason: null,
      submissions: [
        {
          id: 1,
          submitted_at: '2026-06-14T10:22:00Z',
          status: 'submitted',
          decline_reason: null,
          details: {
            asn: 'ASN00009',
            ip_prefixes: ['203.0.113.0/24'],
            latency_sensitivity_ms: 10,
            model_of_routers: ['Cisco ASR 9000'],
            location_of_idc: 'Singapore DC1',
            tunnel_endpoints: [
              { router_designation: 'PE-1', tunnel_endpoint_ip: '192.0.2.1' },
            ],
            netflow_details: [                              // ← was []
              { netflow_ip: '10.0.0.1', netflow_version: 'v9', netflow_sampling_rate: '1:1000' },
            ],
            whitelisted_ips: ['10.0.0.0/8'],       // ← was []
            monitoring_ips: ['10.0.0.2'],          // ← was []
            protocol_and_ports: ['TCP/443', 'UDP/53'], // ← was []
            ids_ips_or_gslb_presence: ['Palo Alto NGFW'],    // ← was []
            additional_information: 'Primary link via SingTel',
          },
        },
      ],
    },
  ]
  // TODO: const res = await fetch('/api/buyer/provisioning', { headers: getAuthHeader() })
  // if (!res.ok) throw new Error(`getBuyerProvisionings: ${res.status}`)
  // return res.json()
}

/** @deprecated Use getRFQs */
export const getQuoteRequests = getSellerRFQs  // alias kept for backward compat

/**
 * GET /host/auction/:auction_id
 * Returns on-chain auction detail — limit price, alternatives, timeslots, status.
 */
// export async function getAuctionDetail(auctionId: number): Promise<AuctionDetail> {
//   const res = await fetch(`${BASE}/host/auction/${auctionId}`)
//   if (!res.ok) throw new Error(`getAuctionDetail(${auctionId}): ${res.status}`)
//   return res.json()
// }

// /** @deprecated Use getAuctionDetail */
// export const getRfqDetail = getAuctionDetail  // alias kept for backward compat

/**
 * POST /host/submit_quote/
 * Submits a seller's offer for one or more timeslots in a reverse auction.
 */
// export async function submitOffer(payload: SubmitOfferPayload): Promise<void> {
//   const res = await fetch(`${BASE}/host/submit_quote/`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(payload),
//   })
//   if (!res.ok) {
//     // Surface the error message from Flask if available
//     let detail = `submitOffer: HTTP ${res.status}`
//     try {
//       const body = await res.json()
//       if (body?.error) detail = body.error
//     } catch { /* ignore parse errors */ }
//     throw new Error(detail)
//   }
// }

export async function getSellerInfo(): Promise<{ pop_ids: number[]; account: string; auction_time_limit?: number }> {
  /*const res = await fetch(`${BASE}/host/info/`)
  if (!res.ok) throw new Error(`getSellerInfo: HTTP ${res.status}`)
  return res.json()*/
  return Promise.resolve({ pop_ids: [1], account: '0x42Ea1EcA762950F73eE1248D2A541dC9Ae6bCF21' })
}

// ─── Provisioning forms ──────────────────────────────────────────────────────

/** Blank form template sent by seller → buyer to fill in */
export interface ProvisioningFormTemplate {
  id: number
  order_id: number
  as_id: number
  token_id: number
  pop_label: string
  bandwidth_gbps: number
  timeslot: number
  received_at: string
  status: string   // Pending | Submitted
}

/** Completed form received by seller after buyer fills in and sends via DH */
export interface ProvisioningForm {
  id: number
  order_id: number
  as_id: number
  timeslot: number
  pop_label: string
  action: string
  ip_range: string
  bandwidth_gbps: number
  received_at: string
  status: string   // Pending | Provisioned
  doc_filename?: string
}

// ── Buyer-side ────────────────────────────────────────────────────────────────

export async function getBuyerDetails(_rfqId: string): Promise<Buyer> {
  // ── MOCK — remove when backend is ready ──
  return Promise.resolve({
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    user_id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    chain_wallet: '0x42EA1ECa762950F73eE1248d2A541dC9Ae6BcF21',
    company: {
      name: 'Acme Corp',
      nature_of_business: 'E-Commerce',
      address: {
        address_line_1: '1 Marina Blvd',
        address_line_2: 'Suite 100',
        city: 'Singapore',
        region: 'Singapore',
        postal_code: '189567',
        country_code: 'SG',
      },
    },
    commercial_contact: {
      full_name: 'Jane Doe',
      email: 'jane@acme.com',
      phone: '+65 9123 4567',
      title: 'Head of Network',
      department: 'IT',
      instant_messaging: 'IT',
    },
    primary_technical_contact: {
      full_name: 'John Smith',
      email: 'john@acme.com',
      phone: '+65 9876 5432',
      title: 'Network Engineer',
      department: 'Infrastructure',
      instant_messaging: 'IT',
    },
    secondary_technical_contact: {
      full_name: 'John Smith',
      email: 'john@acme.com',
      phone: '+65 9876 5432',
      title: 'Network Engineer',
      department: 'Infrastructure',
      instant_messaging: 'IT',
    },
    autonomous_systems: [
      {
        id: '1',
        asn: 'ASN00009',
        ip_prefixes: ['200.000.000.1/255', '200.000.000.2/255'],
      },
    ],
  })
  // ── END MOCK ──
  // TODO: replace with real call:
  // const res = await fetch(`/api/seller/rfqs/${orderId}/buyer`, { headers: getAuthHeader() })
  // if (!res.ok) throw new Error(`getBuyerDetails: ${res.status}`)
  // return res.json()
}

export async function getBuyerProvisioningDetails(): Promise<ProvisioningDetails> {
  // ── MOCK — prefill from buyer profile ──
  return Promise.resolve({
    asn: 'ASN00009',
    ip_prefixes: ['203.0.113.0/24'],
    latency_sensitivity_ms: 10,
    model_of_routers: ['Cisco ASR 9000'],
    location_of_idc: 'Singapore DC1',
    tunnel_endpoints: [
      { router_designation: 'PE-1', tunnel_endpoint_ip: '192.0.2.1' },
    ],
    netflow_details: [
      { netflow_ip: '10.0.0.1', netflow_version: 'v9', netflow_sampling_rate: '1:1000' },
    ],
    whitelisted_ips: ['10.0.0.0/8'],
    monitoring_ips: ['10.0.0.2'],
    protocol_and_ports: ['TCP/443', 'UDP/53'],
    ids_ips_or_gslb_presence: ['Palo Alto NGFW'],
    additional_information: '',
  })
  // TODO: const res = await fetch('/api/buyer/profile', { headers: getAuthHeader() })
  // if (!res.ok) throw new Error(`getBuyerProfile: ${res.status}`)
  // return res.json()
}
export async function getBuyerProvisioningForms(): Promise<ProvisioningFormTemplate[]> {
  const res = await fetch(`${BASE}/client/provisioning_forms/`)
  if (!res.ok) throw new Error(`getBuyerProvisioningForms: HTTP ${res.status}`)
  return res.json()
}

export async function submitProvisioningForm(
  formId: number,
  fields: { action: string; ip_range: string }
): Promise<void> {
  const res = await fetch(`${BASE}/client/provisioning_forms/${formId}/submit`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(fields),
  })
  if (!res.ok) {
    let detail = `submitProvisioningForm: HTTP ${res.status}`
    try { const b = await res.json(); if (b?.error) detail = b.error } catch { }
    throw new Error(detail)
  }
}

// ── Seller-side ───────────────────────────────────────────────────────────────

export async function getProvisioningForms(): Promise<ProvisioningForm[]> {
  const res = await fetch(`${BASE}/host/provisioning_forms/`)
  if (!res.ok) throw new Error(`getProvisioningForms: HTTP ${res.status}`)
  return res.json()
}

export async function sendProvisioningForm(
  orderId: number, asId: number, tokenId: number
): Promise<void> {
  const res = await fetch(`${BASE}/host/send_provisioning_form/`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ order_id: orderId, as_id: asId, token_id: tokenId }),
  })
  if (!res.ok) {
    let detail = `sendProvisioningForm: HTTP ${res.status}`
    try { const b = await res.json(); if (b?.error) detail = b.error } catch { }
    throw new Error(detail)
  }
}

export async function acknowledgeForm(formId: number): Promise<void> {
  const res = await fetch(`${BASE}/host/provisioning_forms/${formId}/acknowledge`, { method: 'POST' })
  if (!res.ok) throw new Error(`acknowledgeForm: HTTP ${res.status}`)
}

/** Returns the URL to download the provisioning document for a given form ID. */
export function provisioningFormDownloadUrl(formId: number): string {
  return `${BASE}/host/provisioning_forms/${formId}/download`
}

// /** @deprecated Use submitOffer */
// export const submitBid = submitOffer
// /** @deprecated Use submitOffer */
// export const submitQuote = submitOffer

/**
 * POST /client/redeem_filter/
 * Initiates filter rule delivery for a settled auction slot. (Q3 2026)
 */
export async function redeemFilter(payload: {
  order_id: number
  as_id: number
  token_id: number
  filter_entry: string | { cmd: string; params: string }
  rfq_id?: number   // same as order_id; used to locate FilterSlotDH contract
}): Promise<void> {
  const res = await fetch(`${BASE}/client/redeem_filter/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(`redeemFilter: ${res.status}`)
}
/*

export async function login(username: string, password: string): Promise<string> {
  const form = new URLSearchParams()
  form.append('username', username)
  form.append('password', password)
  const res = await fetch(`${BASE}/api/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: form,
  })
  if (!res.ok) throw new Error('Login failed')
  const data = await res.json()
  setToken(data.access_token)
  return data.access_token
}*/
